import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";
import { useThemeColors } from "../../Context/Theme";
import "../CSS/Event.css";
import { fetchEvents } from "../../Features/Events/EventSlice";
import moment from "moment/moment";
import { BLACK, PRIMARY } from "../../styles/color";
import { Box, Stack, Typography, useMediaQuery, Button } from "@mui/material";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";


const Event = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const dispatch = useDispatch();

  // Fetch the events from Redux store
  const events = useSelector((state) => state.events.events);
  const loading = useSelector((state) => state.events.loading);
  const isMobile = useMediaQuery("(max-width: 425px)");

  useEffect(() => {
    // Fetch events when the component mounts

    dispatch(fetchEvents());
  }, [dispatch]);

  const latestEvent =
    events &&
    events?.find((n) => n?.event_id == sessionStorage?.getItem("event_id"));



  return (
    <Grid
      container
      xs={12}
      md={12}
      justifyContent="space-evenly"
      alignItems="center"
      className="bg-image1 event-container fo_css_event_event_detail_content"
      style={{
        border: "1.5px dashed #DFDFDF",
        margin: "5vh auto",
        padding: "0 0 40px 0",
        maxWidth: "91.6%",
        boxSizing: "border-box",
        borderRadius: "25px",
      }}
    >
      <Grid
        item
        xs={12}
        md={5}
        width={"100%"}
        className="d-flex justify-content-center"
        style={{ position: "relative", padding: "20px" }}
      >
        <Stack
          alignItems={"center"}
          justifyContent={"start"}
          sx={{
            paddingY: "20px",
            width: "100%",
            height: "100%",

          }}
        >
          <Stack width="100%" height="100%" gap={4}>
            <Stack
              minHeight="max-content"
              sx={{
                borderRadius: "32px",
                width: "100%",

              }}
            >
              <Box
                sx={{
                  padding: "10px",
                  marginBottom: "10px",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <Stack
                  direction="row"
                  sx={{
                    backgroundImage: `url(${latestEvent?.event_img_path})`,
                    height: { xs: "230px", sm: "300px", md: "300px" },
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "32px",
                    width: "100%",
                  }}
                  spacing={2}
                ></Stack>
                <Stack
                  position="absolute"
                  bottom="-15%"
                  justifyContent="center"
                  alignItems="end"
                  sx={{
                    borderRadius: "10px",
                    width: "85%",
                    background: "#FE3B3E",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  }}
                >
                  <Stack
                    sx={{
                      borderRadius: "10px 15px 15px 10px",
                      width: "98%",
                      background: "white",
                    }}
                    padding={1}
                    spacing={1}
                  >
                    <p
                      style={{
                        color: "black",
                        fontSize: fontSizeHeading || { xs: "20px", sm: "22px", md: "24px" },
                        fontWeight: fontWeightHeading || "700",
                        fontFamily: fontFamilyHeading
                      }}
                    >
                      {latestEvent?.event_name}
                    </p>
                    <Stack
                      alignItems="end"
                      direction="row"
                      sx={{
                        color: "#565656",
                        fontSize: fontSize || { xs: "14px", sm: "16px" },
                        fontWeight: fontWeight || "500",
                        fontFamily,
                        gap: "10px",
                      }}
                    >
                      <FmdGoodOutlinedIcon sx={{ color: "#FE3B3E" }} />
                      <Typography style={{ fontFamily, fontSize, fontWeight }}>{latestEvent?.event_address}</Typography>
                    </Stack>
                    <Stack
                      direction={isMobile ? "column" : "row"}
                      alignItems="end"
                      sx={{
                        color: "#565656",
                        fontSize: fontSize || { xs: "14px", sm: "16px" },
                        fontWeight: fontWeight || "500",
                        gap: "10px",
                        fontFamily
                      }}
                    >
                      <Stack direction="row" width={"100%"} gap={"10px"}>
                        <CalendarTodayOutlinedIcon sx={{ color: "#FE3B3E" }} />
                        <Typography width={"100%"} style={{ fontFamily, fontSize, fontWeight }}>
                          <span className="fw-bold">Event Date:</span> {moment(latestEvent?.event_start_date).format(
                            "MMM DD, YYYY"
                          )} - {moment(latestEvent?.event_end_date).format(
                            "MMM DD, YYYY"
                          )}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          </Stack>
        </Stack >
      </Grid >

      <Grid
        item
        xs={12}
        md={6}
        padding={{ xs: "20px 20px 10px 20px", md: "0px 20px" }}
        className="d-flex flex-column justify-content-center"
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'center' }}>
          <p
            style={{
              color: primaryColor || PRIMARY,
              fontSize: fontSizeHeading || "18px",
              fontWeight: fontWeightHeading || "600",
              fontFamily: fontFamilyHeading
            }}
          >
            {latestEvent?.heading}
          </p>
          <p
            className="fw-bold mb-1"
            style={{
              fontSize: fontSizeHeading || "35px",
              fontWeight: fontWeightHeading || "700",
              color: textColor || "black",
              fontFamily: fontFamilyHeading
            }}
          >
            ORDER THAT | {latestEvent?.event_name || "ORDER THAT | Geico"}
          </p>
        </div>
        <div className="mb-2">
          <p style={{ fontSize: fontSize || "18px", fontWeight: fontWeight || "400", color: "#6F6F6F", fontFamily }}>
            {latestEvent?.content || "Event Description goes here."}
          </p>
        </div>
      </Grid>
    </Grid>
  );
};

export default Event;
